import {
    REQUEST as req,
    RESPONSE as res,
    FAILURE as fail,
    CLEAR as clear
} from '../../actions/segments/create';

const initialState = {
    response: {},
    isLoading: false,
    error: null
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case req:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case res:
            return {
                ...state,
                isLoading: false,
                response: action.payload,
                error: null
            };
        case fail:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case clear:
            return {
                ...initialState
            };
        default:
            return state;
    }
}; 